import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Button, Typography, Form, Select, InputNumber } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { InboundMonitoringContext } from "./context-form";

import { filteringCountry } from "../../../helpers/filterCountry";
import { COLORS } from "~constants";

const { Paragraph } = Typography;

const NonPHResidentSection = () => {
  var nationalities = require("i18n-nationality");
  nationalities.registerLocale(require("i18n-nationality/langs/en.json"));
  const data = nationalities.getNames("en");

  const generateNationalityOptions = () => {
    let options = [];
    Object.keys(data).forEach((code) => {
      options.push({ value: data[`${code}`], label: data[`${code}`] });
    });
    return options;
  };

  const filteredCountry = filteringCountry();
  const [failed, setisFailed] = useState(false);
  let { isFailed } = useContext(InboundMonitoringContext);

  useEffect(() => {
    setisFailed(isFailed);
  }, [isFailed]);

  return (
    <>
      {failed && (
        <Row justify="center" align="center">
          <Paragraph type="danger">
            <b>Error Submitting Report:</b>
            &nbsp;Please check input fields and make sure you didn't miss
            anything!
          </Paragraph>
        </Row>
      )}

      <Form.List name={"nonPhResident"}>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }, index) => (
              <Row
                gutter={10}
                justify="space-between"
                align="center"
                key={key}
                style={{ marginBottom: 10 }}
              >
                <Col key={`inputFieldName_0`} span={12}>
                  <Paragraph level={5}>Nationality</Paragraph>
                </Col>
                <Col key={`inputFieldName_1`} span={6}>
                  <Paragraph level={5}>Male</Paragraph>
                </Col>
                <Col key={`inputFieldName_2`} span={6}>
                  <Paragraph level={5}>Female</Paragraph>
                </Col>
                <Col key={`inputFieldName_3`} span={12}>
                  <Form.Item
                    {...restField}
                    name={[name, "nationality"]}
                    rules={[
                      {
                        required: true,
                        message: "Please select a nationality!",
                      },
                    ]}
                  >
                    <Select options={generateNationalityOptions()} />
                  </Form.Item>
                </Col>

                <Col key={`inputFields_4`} span={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "male"]}
                    rules={[
                      {
                        required: true,
                        message: "Please input number of male",
                      },
                    ]}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col key={`inputFields_5`} span={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "female"]}
                    rules={[
                      {
                        required: true,
                        message: "Please input number of female",
                      },
                    ]}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Paragraph level={5}>
                    <center>{"Point of Origin"}</center>
                  </Paragraph>
                </Col>
                <Col span={24}>
                  <Form.Item
                    {...restField}
                    name={[name, "country"]}
                    rules={[
                      {
                        required: true,
                        message: "Please select a country!",
                      },
                    ]}
                  >
                    <Select
                      style={{ textAlign: "center" }}
                      placeholder={"(Based On Country)"}
                      options={filteredCountry}
                    />
                  </Form.Item>
                </Col>
                <Col span={24} style={{ marginBottom: 10 }}>
                  <center>
                    <Button
                      // block
                      danger
                      type="primary"
                      size="middle"
                      onClick={() => remove(index)}
                    >
                      Remove Record
                    </Button>
                  </center>
                  {/* <CloseCircleOutlined
                    style={{
                      color: COLORS.red,
                      fontSize: 20,
                      margin: "10px 0 10px 0",
                    }}
                    onClick={() => remove(index)}
                  /> */}
                </Col>
              </Row>
            ))}
            <Row>
              <Button
                block
                onClick={() => add()}
                type="primary"
                icon={<PlusOutlined />}
              >
                ADD MORE
              </Button>
            </Row>
          </>
        )}
      </Form.List>
      <Row style={{ margin: "20px 0 50px 0" }}>
        <Col span={12}>
          <Button
            size="large"
            htmlType="reset"
            style={{ backgroundColor: COLORS.blue1 }}
          >
            Reset
          </Button>
        </Col>
        <Col span={12} style={{ justifyContent: "flex-end", display: "flex" }}>
          <Button
            size="large"
            htmlType="submit"
            style={{ backgroundColor: COLORS.orange }}
          >
            Save
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default NonPHResidentSection;
